import * as React from 'react';
import { RouteComponentProps } from 'react-router';


export class NotFound404 extends React.Component<RouteComponentProps<{}>> {
    constructor(props: RouteComponentProps<{}>) {
        super(props);
        this.state = { helpCtxId: '' };
    }

    public render() {
        return <div className='otc-help'>
            <h3>Not Found - 404</h3>
        </div>;
    }
}
